import React from 'react'
import './../styles/OurServices.css'

const services = {
  'AI & Automation': [
    'AI-Powered Testing',
    'Machine Learning QA',
    'Intelligent Test Automation',
    'AI Code Analysis',
    'Automated Bug Detection',
    'Smart Test Case Generation',
    'AI Performance Optimization',
  ],
  'Software Testing Models': [
    'Managed Testing Services',
    'Software Testers for Hire',
    'QA Outsourcing',
    'QA Consulting',
    'Dedicated QA Team',
    'QA as a Service',
  ],
  'Testing Solutions': [
    'Test Automation',
    'Performance Testing',
    'End-to-End Testing',
    'Load and Stress Testing',
    'API Testing',
    'Accessibility Testing',
    'Security Testing',
    'Regression Testing',
    'Integration Testing',
    'User Acceptance Testing',
  ],
  'Technologies & Tools': [
    'JavaScript/TypeScript',
    'Java & .NET/C#',
    'Python & Go',
    'Selenium & Cypress',
    'Playwright & WebDriver',
    'Cucumber & Mocha',
    'Jenkins & Docker',
    'AWS & Azure',
  ],
  'Platforms & Systems': [
    'Web Applications',
    'Mobile Apps (iOS/Android)',
    'Cloud Platforms',
    'SaaS Solutions',
    'IoT Systems',
    'Blockchain',
    'Enterprise Systems',
    'Microservices',
  ],
  'Training & Resourcing': [
    'Talent Acquisition',
    'QA Team Building',
    'Technical Recruitment',
    'Skills Assessment',
    'Outsourcing / Offshoring',
    'QA Training Programs',
    'Best Practices Workshops',
    'Team Development',
    'Technical Mentoring',
  ],
}

const OurServices = () => (
  <section className="services-section">
    <div className="services-container">
      <div className="services-header">
        <h2 className="services-title">Our Comprehensive Services</h2>
        <p className="services-subtitle">
          Cutting-edge QA solutions powered by modern technology and AI innovation
        </p>
      </div>
      <div className="services-grid">
        {Object.entries(services).map(([category, items]) => (
          <div className="service-category" key={category}>
            <div className="category-header">
              <h3 className="category-title">{category}</h3>
              <div className="category-icon"></div>
            </div>
            <ul className="services-list">
              {items.map((item) => (
                <li key={item} className="service-item">
                  <span className="service-bullet">•</span>
                  {item}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  </section>
)

export default OurServices
